import { CSSProperties } from 'react';

export default {
    inlineContainer: {
        marginBottom: 8,
        backgroundColor: 'white',
        padding: '12px 0px'
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 4
    },
    image: {
        width: '100%',
        borderRadius: 8
    },
    title: {
        fontSize: 18
    },
    description: {
        fontSize: 12,
        marginTop: 4,
        marginBottom: 4,
        marginRight: 12
    },
    button: {
        flexShrink: 0,
        padding: '8px 16px',
        borderRadius: 4,
        color: 'white',
        textTransform: 'uppercase',
        fontSize: 12,
        textDecoration: 'none',
        textAlign: 'center'
    },
    modalContent: {
        padding: '0 24px',
        textAlign: 'center'
    },
    closeButton: {
        display: 'flex',
        backgroundColor: 'white',
        position: 'absolute',
        top: -5,
        right: -5,
        width: 30,
        height: 30,
        zIndex: 1000,
        borderRadius: '50%',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
    }
} as Record<string, CSSProperties>;

export const modalStyles = {
    content: {
        backgroundColor: 'white',
        overflow: 'visible',
        borderRadius: 34,
        border: 'none',
        padding: 0,
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxWidth: 450,
        position: 'relative',
        outline: 'none'
    },
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.32)',
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20
    }
};
